package org.example.zone360.pages.dashboard.coaches

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaCopy
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.createCoach
import org.example.zone360.utils.getAllTeams
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.InputField
import org.example.zone360.components.TokenSearch
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetAllTeamsData
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.AppGlobal.Companion.teamDataList
import org.example.zone360.utils.Res
import org.example.zone360.utils.extractContentText
import org.example.zone360.utils.isValidEmail
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Composable
fun AddNewCoach(onDialogDismiss: (Long) -> Unit,
                 breakpoint: Breakpoint,
                 modalNumber: Long,
                 toastMessageCall: (String) -> Unit,
                onSave: () -> Unit,
                onLimitReach: (Boolean) -> Unit
) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()
    var isLoading by remember { mutableStateOf(false) }
    var serverError by remember { mutableStateOf("") }
    var isError by remember { mutableStateOf(false) }
    var isTeamError by remember { mutableStateOf(false) }
    var isEmailExistError by remember { mutableStateOf(false) }

    val teams = remember { mutableStateListOf<GetAllTeamsData>() }
    val selectedTeams = remember { mutableStateListOf<String>() }
    var copyIcon by remember { mutableStateOf(false) }
    var isCopied by remember { mutableStateOf(false) }
    var messageToCopy by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        scope.launch {
            try {
                val response = getAllTeams(
                    clubName = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId
                )
                teamDataList.clear()
                teamDataList.addAll(response.data)
            } catch (e: Exception) {
                console.error("Error fetching teams:", e)
            }
        }
    }


    Box(
        modifier = Modifier
            .width(if (breakpoint < Breakpoint.MD) 400.px else 460.px)
            .position(Position.Fixed)
            .zIndex(9)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .width(90.percent)
                .height(100.percent)
                .onClick { }
        )
        Box(
            modifier = Modifier
                .padding(all = 24.px)
                .width(90.percent)
                .margin(top = 10.px)
                .height(100.percent)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .borderRadius(4.px)
            ,
            contentAlignment = Alignment.Center,
        ) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        FieldTitleTextNormalSimple(
                            "Add New Coach",
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {}
                        )
                    }

                    FaXmark(
                        modifier = Modifier
                            .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer)
                            .onClick { onDialogDismiss(modalNumber) },
                        size = IconSize.LG
                    )

                }
                Column(
                    Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.Center
                ) {
                    FieldTitleTextNormal(text = "Email", onClick = {})
                    InputField(
                        errorText = "Please enter an email (e.g. name@domain.com).",
                        isError = isEmailExistError || isError,
                        inputType = InputType.Email,
                        placeHolder = "",
                        marginBottom =  3.px,
                        id = "${Res.Id.emailInput}-$modalNumber",
                        width = if (breakpoint < Breakpoint.MD) 290.px else 360.px
                    )
                    CustomSpacer(height = 20.px)
                    FieldTitleTextNormal(text = "First Name", onClick = {})
                    InputField(
                        errorText = "Please enter first name",
                        isError = isError,
                        inputType = InputType.Text,
                        placeHolder = "",
                        marginBottom =  3.px,
                        id = "${Res.Id.firstName}-$modalNumber",
                        width = if (breakpoint < Breakpoint.MD) 290.px else 360.px
                    )
                    CustomSpacer(height = 20.px)

                    FieldTitleTextNormal(text = "Last Name", onClick = {})
                    InputField(
                        inputType = InputType.Text,
                        placeHolder = "",
                        marginBottom = 3.px,
                        errorText = "Please enter last name",
                        isError = isError,
                        id = "${Res.Id.lastName}-$modalNumber",
                        width = if (breakpoint < Breakpoint.MD) 290.px else 360.px

                    )
                    CustomSpacer(height = 20.px)
                    FieldTitleTextNormal(text = "Select Team(s)", onClick = {})
                        TokenSearch(
                            data = teamDataList.map { it.teamName },
                            selectedData = selectedTeams,
                            onSelected = {
                                if (!selectedTeams.contains(it))
                                selectedTeams.add(it)
                                isTeamError = false
                                         },
                            onRemoved = { selectedTeams.remove(it) },
                            width = if (breakpoint < Breakpoint.MD) 290.px else 360.px,
                            openUpward = true,
                        )
                    if (isTeamError) {
                        FieldTitleTextNormal(
                            marginTop = 3.px,
                            fontSize = 11.px,
                            text = "Please select at least one team",
                            color = sitePalette.textErrorColor.rgb, onClick = {}
                        )
                    }

                    CustomSpacer(height = 30.px)

                }


                Box {
                    CommonButton(
                        byPassEmailVerification = true,
                        text = "Save",
                        isLoading = isLoading,
                        onCLick = {
                            scope.launch {
                                val emailInput =
                                    (document.getElementById("${Res.Id.emailInput}-$modalNumber") as HTMLInputElement).value
                                val firstNameInput =
                                    (document.getElementById("${Res.Id.firstName}-$modalNumber") as HTMLInputElement).value
                                val lastNameInput =
                                    (document.getElementById("${Res.Id.lastName}-$modalNumber") as HTMLInputElement).value
                                serverError = ""
                                isError = false
                                isEmailExistError = false

                                when {
                                    emailInput.isEmpty() -> {
                                        isError = true
                                    }
                                    !isValidEmail(email = emailInput) -> {
                                        isError = true
                                    }
                                    firstNameInput.isEmpty() -> {
                                        isError = true
                                    }

                                    lastNameInput.isEmpty() -> {
                                        isError = true
                                    }
                                    selectedTeams.isEmpty() -> {
                                        isTeamError = true
                                    }

                                    else -> {
                                        isLoading = true
                                        isError = false
                                        isTeamError = false

                                        try {
                                            val response = createCoach(
                                                email = emailInput,
                                                firstName = firstNameInput,
                                                lastName = lastNameInput,
                                                imageUrl = "",
                                                organization = AppGlobal.userData.organization,
                                                teams = selectedTeams
                                            )
                                            if (response.data!="") {
                                                toastMessageCall("Coach created successfully")
                                                showToast("toastSuccess")
                                                messageToCopy = extractContentText(response.data)
                                                copyIcon = true
                                                isCopied = false
//                                                onDialogDismiss(modalNumber)
                                                onSave()
                                            }  else if (response.message.isNotEmpty()){
                                                toastMessageCall(response.message)
                                                showToast("toastSuccess")
                                                onSave()
                                                } else {
                                                isError = true
                                                serverError =response.error
                                                if (response.error.contains("reached maximum limit of users allowed!")){
                                                    onLimitReach(true)
                                                }
                                            }
                                        } catch (e: Exception) {
                                            isError = true
                                            serverError = e.message ?: "Something went wrong"

                                            if (serverError.contains("reached maximum limit of users allowed!")){
                                                onLimitReach(true)
                                            }
                                        } finally {
                                            isLoading = false
                                        }
                                    }
                                }
                            }
                        },
                        width = if (breakpoint < Breakpoint.MD) 290.px else 360.px,
                        height = 45.px
                    )
                }
                if (copyIcon) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = 10.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            "📋 Share Invitation",
                            fontSize = 14.px,
                            fontWeight = 500,
                            marginBottom = 8.px
                        )
                        CustomSpacer(width = 20.px)
                        Box(
                            modifier = Modifier
                                .borderRadius(6.px)
                                .border(1.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                                .padding(leftRight = 16.px, topBottom = 6.px)
                                .cursor(if (isCopied) Cursor.Default else Cursor.Pointer)
                                .onClick {
                                    if (!isCopied) {
                                        window.navigator.clipboard.writeText(messageToCopy)
                                        isCopied = true
                                    }
                                }
                        ) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.Center
                            ) {
                                if (isCopied) {
                                    FaCheck(modifier = Modifier.margin(right = 6.px), size = IconSize.SM)
                                    FieldTitleTextNormalSimple(
                                        "Copied!",
                                        fontSize = 14.px,
                                        fontWeight = 500,
                                    )
                                } else {
                                    FaCopy(modifier = Modifier.margin(right = 6.px), size = IconSize.SM)
                                    FieldTitleTextNormalSimple(
                                        "Copy Link",
                                        fontSize = 14.px,
                                        fontWeight = 500,
                                        isClickable = true
                                    )
                                }
                            }
                        }
                    }
                }

                if (serverError.isNotEmpty()) {
                Row (modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center){
                    FieldTitleTextNormal(
                        text = serverError,
                        color = sitePalette.textErrorColor.rgb,
                        fontSize = 12.px,
                        marginTop = 10.px,
                        textAlign = TextAlign.Center,
                        onClick = {})
                }}
            }
        }
    }
}